export default d => !d.path || d.path === '' || !d.name || d.name === ''
